import React from 'react'
 import 'sweetalert2/dist/sweetalert2.all';
import Swal from 'sweetalert2';
export default function alert_box(title, text, icon, confirmButtonText) {
  return (
    Swal.fire({
        title: title || '',
        text: text || '',
        icon: icon || 'info',
        confirmButtonText: confirmButtonText || 'ok',
        
      })
  )
}

